import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import es from "./locales/es.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es }
    },
    // lng: localStorage.getItem("mercadito_lang") || "en",
    fallbackLng: "en", // default language
    detection: {
      // Detect language from localStorage
      order: ["localStorage", "cookie", "navigator"],
      lookupLocalStorage: "mercadito_lang",
      caches: ["localStorage", "cookie"]
    },
    debug: true, // Optional for logging
    defaultNS: "translation",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
